// import React from 'react'
// import './home.css'
// import { SlScreenSmartphone } from "react-icons/sl";
// import { Link } from 'react-router-dom';
// const Home = () => {
//   return ( 
//     <section className='home-overlay'>
//          <div className='home-container'>
//             <section className='container homeinnercontainer'>
//                 <article className='homeleft'>
//                     <div className='phonenumber'><span className='phonespan'><SlScreenSmartphone className='num iconss' /><a href='tel:+2348085312366' className='num'>+234 808 531 2366</a></span></div>
//                     <h1 className='homebigtext'>Your Journey to the Perfect Property Starts Here.</h1>
//                     <div className=''>
//                         <p className='homeparagraph'>Navigating the real estate market can be both exciting and challenging. Whether you’re searching for your dream home, aiming to sell your current property, or looking for a savvy investment, EAEKANEM CONSULTING is your dedicated partner.</p>
//                     <button className="buttoncontainer"><Link to='/contact'>Contact Us</Link></button>
//                     </div>
                    
//                 </article>
//                 <article className='homeright'>
//                     <div className='formcontainer'>
//                         <p>Need help?</p>
//                         <h2>Send us a message</h2>
                   
//                     <form className="contact-form">
//                         <div className="form-group">
//                             <input type="text" id="name" name="name" placeholder="Enter your name" required />
//                         </div>
//                         <div className="form-group">
//                             <input type="email" id="email" name="email" placeholder="Enter your email" required />
//                         </div>

//                         <div className="form-group">
//                             <textarea id="message" name="message" rows="5" placeholder="Enter your message" required></textarea>
//                         </div>

//                         <button type="submit" className="send-btn">Send Message</button>
//                     </form>
//                      </div>
//                 </article>
//             </section>
//         </div>
//     </section>
   
//   )
// }

// export default Home


import React, { useState } from "react";
import "./home.css";
import { SlScreenSmartphone } from "react-icons/sl";
import { Link } from "react-router-dom";

const Home = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          access_key: "63ce8990-b264-402a-a6bf-4719e90a52d0", // 🟢 Replace with your Web3Forms key
          ...formData,
        }),
      });

      const result = await response.json();

      if (result.success) {
        setStatus("success");
        setFormData({ name: "", email: "", message: "" });
      } else {
        setStatus("error");
      }
    } catch {
      setStatus("error");
    }
  };

  return (
    <section className="home-overlay">
      <div className="home-container">
        <section className="container homeinnercontainer">
          {/* === LEFT SIDE === */}
          <article className="homeleft">
            <div className="phonenumber">
              <span className="phonespan">
                <SlScreenSmartphone className="num iconss" />
                <a href="tel:+2348085312366" className="num">
                  +234 808 531 2366
                </a>
              </span>
            </div>
            <h1 className="homebigtext">
              Your Journey to the Perfect Property Starts Here.
            </h1>
            <p className="homeparagraph">
              Navigating the real estate market can be both exciting and
              challenging. Whether you’re searching for your dream home, aiming
              to sell your current property, or looking for a savvy investment,
              <b> EAEKANEM CONSULTING </b> is your dedicated partner.
            </p>
            <button className="buttoncontainer">
              <Link to="/contact">Contact Us</Link>
            </button>
          </article>

          {/* === RIGHT SIDE FORM === */}
          <article className="homeright">
            <div className="formcontainer">
              <p>Need help?</p>
              <h2>Send us a message</h2>

              <form className="contact-form" onSubmit={handleSubmit}>
                <input type="hidden" name="access_key" value="your-access-key-here" />

                <div className="form-group">
                  <input
                    type="text"
                    name="name"
                    placeholder="Enter your name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <input
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <textarea
                    name="message"
                    rows="5"
                    placeholder="Enter your message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>

                <button type="submit" className="send-btn">
                  {status === "sending" ? "Sending..." : "Send Message"}
                </button>

                {status === "success" && (
                  <p className="success-msg">✅ Message sent successfully!</p>
                )}
                {status === "error" && (
                  <p className="error-msg">❌ Something went wrong. Try again.</p>
                )}
              </form>
            </div>
          </article>
        </section>
      </div>
    </section>
  );
};

export default Home;
